export default __webpack_public_path__ + "static/media/icon-add.42743323.svg";